import GenericAreaPage from "@/components/GenericAreaPage";
import { getAreaContent } from "@/lib/area-content";

const SugarLand = () => {
  const content = getAreaContent("sugar-land");
  if (!content) return null;
  return <GenericAreaPage content={content} />;
};

export default SugarLand;